import styled from '@emotion/styled'
import { gapY } from '@mobi/component-library/Utils/gap'
import { colors, font, radius, shadow, spacing } from '@mobi/component-library/Theme/Common'

export const CampaignDescriptionStyled = styled.span({
  textAlign: 'center',
  ...font.size.md,
  fontWeight: font.weight.medium,
  color: colors.greyDark,
  marginTop: spacing.lgx2,
  a: {
    color: colors.studio[500],
    textDecoration: 'none',
  },
})

export const BonusCardContainer = styled.div({
  background: colors.white,
  borderRadius: radius.lgx1,
  boxShadow: shadow.xs,
})

export const BonusCardHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: colors.studio[500],
  color: colors.studio[50],
  padding: ` 1rem ${spacing.sm}`,
  fontWeight: font.weight.medium,
  fontSize: font.size.md.fontSize,
  gap: spacing.smx2,
  borderTopLeftRadius: radius.lgx1,
  borderTopRightRadius: radius.lgx1,
})

export const BonusCardTitle = styled.span({
  ...font.size.lg,
  fontWeight: font.weight.semibold,
})

export const BonusCardExpiry = styled.span({
  marginLeft: 'auto',
  ...font.size.md,
})

export const BonusCardBody = styled.div(
  {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: spacing.sm,
    background: colors.white,
    borderBottomLeftRadius: radius.lgx1,
    borderBottomRightRadius: radius.lgx1,
    border: `1px solid ${colors.neutral[200]}`,
  },
  gapY(spacing.smx1)
)

export const BonusCardDescription = styled.div({
  ...font.size.md,
  fontWeight: font.weight.regular,
  color: colors.neutral[900],
})

export const BonusCardTotal = styled.div({
  fontWeight: font.weight.semibold,
  ...font.size.lg,
  color: colors.black,
  marginBottom: spacing.smx2,
})

export const BonusCardRemaining = styled.div({
  background: colors.neutral[200],
  color: colors.neutral[900],
  borderRadius: radius.sm,
  padding: `0.2rem ${spacing.smx2}`,
  ...font.size.base,
  fontWeight: font.weight.medium,
})
